import React, { useEffect, useState } from 'react';

import PageSection from '../../PageSections/PageSection';
import Tab from './Tab';
import * as styles from './TabsSection.module.scss';

const TabShape = () => (
  <svg
    className={styles.tabShape}
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    fill="none"
    viewBox="0 0 417 59"
  >
    <path
      className={styles.fill}
      d="m13.04 47.802 13.62-36.114C28.07 5.52 33.9.5 39.7.5v58.49H0c5.8 0 11.64-7.549 13.04-11.188"
    ></path>
    <path
      className={styles.border}
      d="m12.57 47.632 13.62-36.114C27.67 5.159 33.72 0 39.7 0v.99c-5.56 0-11.19 4.849-12.55 10.798l-.49-.11.47.17-13.62 36.114-.47-.17.47.18C12.2 51.382 7.67 57.29 2.68 58.99H.01v-.5c5.43 0 11.15-7.179 12.57-10.868z"
    ></path>
    <path
      className={styles.fill}
      d="m403.66 47.802-13.62-36.114C388.63 5.52 382.8.5 377 .5v58.49h39.7c-5.8 0-11.64-7.549-13.04-11.188"
    ></path>
    <path
      className={styles.border}
      d="m404.13 47.632-13.62-36.114C389.03 5.159 382.98 0 377 0v.99c5.56 0 11.19 4.849 12.55 10.798l.49-.11-.47.17 13.62 36.114.47-.17-.47.18c1.31 3.41 5.84 9.318 10.83 11.018h2.67v-.5c-5.43 0-11.15-7.179-12.57-10.868z"
    ></path>
    <path className={styles.fill} d="M39 0h339v59H39z"></path>
    <path className={styles.border} fillRule="evenodd" d="M378 1H39V0h339z" clipRule="evenodd"></path>
  </svg>
);

export default function TabsSection({ section, smallTabs = false, className = '', activeTabIndex = 0 }) {
  const [activeTab, setActiveTab] = useState(activeTabIndex);
  useEffect(() => {
    setActiveTab(activeTabIndex);
  }, [activeTabIndex]);

  return (
    <PageSection
      slim
      className={className}
      innerClassName={styles.tabsSection}
      data-analytics-section={'tabbed-folder-section'}
    >
      <div
        className={[styles.tabLabels, smallTabs ? styles.smallTabs : '', styles[section[activeTab].accentColor]].join(
          ' '
        )}
        style={{ gridTemplateColumns: `repeat(${section.length}, 1fr)` }}
      >
        {section.map((tab, i) => (
          <button
            key={i}
            className={[styles.label, activeTab === i ? styles.active : ''].join(' ')}
            onClick={() => setActiveTab(i)}
          >
            <TabShape />
            <span>{tab.heading}</span>
          </button>
        ))}
      </div>
      <div className={styles.tabContent}>
        {section.map((tab, i) => (
          <Tab key={i} tab={tab} isActive={activeTab === i} />
        ))}
      </div>
    </PageSection>
  );
}
